import React from "react";

const QuestionLoadingSkeleton = () => {
  return (
    <div className="animate-pulse flex flex-col justify-between w-full h-full gap-6 md:gap-8">
      <div className="flex-1 space-y-4 md:space-y-6">
        <div className="h-2 md:h-3 bg-slate-200 rounded w-3/4"></div>
        <div className="h-2 md:h-3 bg-slate-200 rounded w-1/2"></div>
        <div className="space-y-3 md:space-y-4 pt-2">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
            <div className="h-2 md:h-3 bg-slate-200 rounded"></div>
            <div className="h-2 md:h-3 bg-slate-200 rounded hidden md:block"></div>
            <div className="h-2 md:h-3 bg-slate-200 rounded hidden md:block"></div>
            <div className="h-2 md:h-3 bg-slate-200 rounded"></div>
            <div className="h-2 md:h-3 bg-slate-200 rounded hidden md:block"></div>
            <div className="h-2 md:h-3 bg-slate-200 rounded hidden md:block"></div>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="h-2 md:h-3 bg-slate-200 rounded w-16 md:w-20"></div>
        <div className="h-2 md:h-3 bg-slate-200 rounded w-24 md:w-28"></div>
      </div>
    </div>
  );
};

export default QuestionLoadingSkeleton;
